// extracted by mini-css-extract-plugin
export default {"container":"ResultsList_container__CaIXR","list":"ResultsList_list__LruFv","price-info-text":"ResultsList_price-info-text__vFZXc"};